import React from 'react';
import { BeneficiaryDTO } from '../../../../api/useEstatePlanningExplanationQuery';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../../../../CommonComponents/OPL/Text/Text';
import { formatPercentage } from '../../../../../../../../CommonUtils/formatNumber';

interface Props {
  beneficiaries: BeneficiaryDTO[] | null;
}

export const BeneficiariesList = ({ beneficiaries }: Props) => {
  if (!beneficiaries || beneficiaries.length === 0) {
    return <>-</>;
  }

  return (
    <Box as="ul" css="list-style: none" p="0">
      {beneficiaries.map(({ Name, Percentage, Id }) => (
        <Text as="li" key={Id}>{`${Name} (${formatPercentage(Percentage / 100, {
          mantissa: 2,
          optionalMantissa: true,
        })})`}</Text>
      ))}
    </Box>
  );
};
